module.exports = __webpack_public_path__ + "static/family-2-7acb29ad85ac4860f055ed5c82cc2726.jpg";